import { render, staticRenderFns } from "./ProfessionalServices.vue?vue&type=template&id=b04e2f16"
import script from "./ProfessionalServices.vue?vue&type=script&lang=js"
export * from "./ProfessionalServices.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalServices.vue?vue&type=style&index=0&id=b04e2f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports